<template>
  <div class="container">
    <img class="backImg" :src="data.backImg">
    <div class="headerTitle">
      <img class="titleIcon" :src="data.titleIcon">
      <div class="titleEn">{{ data.titleEn }}</div>
    </div>
    <div class="title">{{ data.titleZh }}</div>
  </div>
</template>
<script>
export default {
  name: "AboutUs",
  props: {
    data: {
      type: Object, default() {
        return {}
      }
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  width: 1700px;
  height: 586px;
  margin: 0 0 41px 109px;
  position: relative;
  padding-top: 32px;

  .backImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 1700px;
    height: 586px;
    border-radius: 24px;
    z-index: -1;
  }

  .headerTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 100px;
    width: fit-content;
    padding: 13px 20px;
    background-color: #FFFFFF;

    .titleIcon {
      width: 33px;
      height: 33.21px;
      margin-right: 5px;
    }

    .titleEn {
      font-size: 24px;
      font-family: "SourceHanSansSC-Bold-2";
      font-weight: bold;
      color: #2A45A7;
    }
  }

  .title {
    box-sizing: border-box;
    width: fit-content;
    padding: 28px 20px;
    background-color: #FFFFFF;
    margin-left: 100px;
    font-size: 64px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #24262B;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/ProductIntroduceAndCase.vue